<template>
	<div class="send-msg-container">
		<div class="tools">
			<div class="emotions-btn pull-left">
				<a class="btn icon icon-biaoqing2 js-open-emotions-btn" href="javascript:;" title="发送表情" @click="$store.commit('changeShowEmotions', true)"></a>
				<ul v-show="$store.state.showEmotions" class="js-emotions-container">
					<template v-if="isIMType($store.state.currentShop.serviceType)">
						<li v-for="i in 104" @click="chooseEmotions(i)"><img :src="emotionsPath(i)"></li>
					</template>
					<template v-else>
						<li v-for="i in 99" v-if="i != 56" @click="chooseEmotions(i)"><img :src="emotionsPath(i)"></li>
					</template>
				</ul>
			</div>

			<label class="btn pic-btn icon icon-tupian1 pull-left js-send-msg-pic" title="发送图片/视频">
				<input type="file" accept="image/*,video/*" @change="sendImg">
			</label>

			<div class="transfer-btn pull-left">
				<a class="btn icon icon-zhuanjie1 js-transfer-btn-list" href="javascript:;" title="转接" @click="clickTransferBtn"></a>

				<ul v-show="$store.state.showTransferTypeList" class="js-transfer-type-list">
					<li @click="getTransferList(2)">内部转接</li>
					<li @click="getTransferList(3)">千牛转接</li>
				</ul>

				<ul v-show="$store.state.showTransferList" class="transfer-list scrollbar js-transfer-list">
					<li v-for="obj in transferList" @click="transfer(obj)">{{ obj.real_name }}</li>
				</ul>
			</div>

			<div v-if="isShowInvite" class="invite-out-box pull-left">
				<a href="javascript:;" class="invite-tip" @click="inviteComments">邀评</a>
			</div>

			<a class="records-btn pull-right" href="javascript:;" @click="getMsgLog" :style="{'color': '#ccc', 'cursor': 'default', 'pointer-events': 'none'}">消息记录</a>

			<robotSelect :styleObj="{'float': 'right', 'margin-right': '13px'}" :sessionId="currentSessionId"></robotSelect>
		</div>

		<form class="send-msg clear" action="javascript:;">
			<divTextarea :classList="'ima_textarea scrollbar'" v-model="sendContent" @keydown="enterMsg" @paste="pasteUploadImg"></divTextarea>
			<div class="btn-box">
				<div v-show="detection" :class="['intelligent-detection-notice', detectionClass]">{{ detection }}</div>
				<a class="button" href="javascript:;" @click="handleSendMessage(sendContent)">发送</a>
				<a class="button gray" href="javascript:;" @click="closeCurrentSession">关闭</a>
			</div>
		</form>
	</div>
</template>

<script>
import robotSelect from '../../components/robotSelect.vue'
import divTextarea from '../../components/divTextarea.vue'
import bus from '@/config/eventBus'
export default {
	name: 'sendMsg',
	data () {
		return {
			sendContent: this.$store.state.sendContent,
			transferList: [],
			transferType: null, // 1：IM转接 2：旺旺内部转接 3：旺旺千牛转接
			detection: '',
			detectionClass: '',
			inputCheckInterval: null,
			qRKey: 'QuickReply-',
			isShowInvite: false
		}
	},
	components: {
		'robotSelect': robotSelect,
		'divTextarea': divTextarea
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		},
		currentSessionId() {
			return this.$store.state.currentSessionId
		},
		conversationList () {
			return this.$store.state.conversationList;
		},
		stateSendCont () {
			return this.$store.state.sendContent
		},
		userInfo () {
			return this.$store.state.userInfo
		}
	},
	watch: {
		sendContent () {
			var self = this;
			if (self.sendContent == self.stateSendCont) return;
			self.$store.commit('changeSendContent', self.sendContent);
			self.aiIntelligentDetection();
		},
		stateSendCont () {
			var self = this;
			if (self.stateSendCont == self.sendContent) return;
			self.sendContent = self.stateSendCont;
			self.aiIntelligentDetection();
		},
		currentSessionId (now, old) {
			if (now == old) return;
			this.saveUnSendContent(old);
			this.getUnSendContent(now);
		},
		currentShop: {
			deep: true,
			handler(now, old) {
				var self = this;
				if (now.id == old.id) return;
				self.getInviteShowSta(now.id)
			}
		}
	},
	mounted () {
		var self = this;
		self.bindQuickReply();
	},
	methods: {
		// 获取邀评按钮展示条件
		getInviteShowSta(id) {
			var self = this;
			self.isShowInvite = false
			let data = {
				shopId: id
			}
			let url = API_ROOT.url + '/IMWebApi.evaluateStatus'
			self.$axios.post(url, data).then(result => {
				self.isShowInvite = result.result ? false : true
			}, response => {
				console.log(response, '<rrrrrrrrrrr')
			})
		},
		// 邀评
		inviteComments() {
			let data = {
				sessionId: this.currentSessionId
			}
			this.$axios.post(API_ROOT.url + '/SessionApi.inviteComments', data).then(result => {
				if (result.status) {
					this.$alert('已发送邀评信息~');
				} else {
					this.$alert('发送邀评失败~');
				}
			}, err => {
				this.$alert('发送邀评失败~');
			})
		},

		// 判断店铺类型是否属于IM类型
		isIMType (type) {
			return TJ_IM.isIMType(type)
		},

		// 表情图片路径
		emotionsPath (i) {
			var self = this;
			if (TJ_IM.isIMType(self.$store.state.currentShop.serviceType)) {
				return '/static/image/expression/' + (i - 1) + '.png';
			} else {
				return '/static/image/emotions/' + (i - 1) + 'fixed.bmp';
			}
		},

		// 选择表情
		chooseEmotions (i) {
			var self = this,
				imgHtml = '';

			if (TJ_IM.isIMType(self.$store.state.currentShop.serviceType)) {
				imgHtml = '<img src="/static/image/expression/' + (i - 1) + '.png" data-type="emotions">';
			} else {
				imgHtml = '<img src="/static/image/emotions/' + (i - 1) + '.gif" data-type="emotions">';
			}

			self.$store.commit('changeShowEmotions', false);
			TJ_IM.addStrToFocus(document.getElementsByClassName('ima_textarea')[0], imgHtml, function(text) {
				self.sendContent = text;
			});
		},

		// 点击转接按钮
		clickTransferBtn () {
			var self = this;

			if (self.currentShop.serviceType == self.$store.state.TYPES.WANGWANG) {
				self.$store.commit('changeShowTransferList', false);
				self.$store.commit('changeShowTransferTypeList', true);
			} else {
				self.getTransferList(1);
			}
		},

		// 关闭当前会话
		closeCurrentSession () {
			this.$emit('closeSession', this.currentSessionId, true)
		},

		// 获取转接列表
		getTransferList (type) {
			var self = this;

			self.transferType = type;

			if (self.transferType == 1) {
				var url = API_ROOT.url + '/CustomerStatusApi.listOnlineCustomer';
			} else if (self.transferType == 2) {
				var url = API_ROOT.url + '/wwim/getTransferabledCustomer';
			} else {
				var url = API_ROOT.url + '/wwim/getTransferList';
			}

			var data = {
				serviceType: self.currentShop.serviceType,
				sessionId: self.currentSessionId,
				shopId: self.currentShop.id
			};

			self.$store.commit('changeShowTransferTypeList', false);
			self.$axios.post(url, data).then(result => {
				if (self.currentSessionId != data.sessionId) return;

				if (result.status) {
					if (!result.data.length) {
						self.$alert('暂无可转接客服');
						return;
					}
					self.transferList = result.data;
					self.$store.commit('changeShowTransferList', true);
				} else {
					self.$alert('获取转接列表失败，失败原因：' + result.msg);
				}
			}, response => {
				if (self.currentSessionId != data.sessionId) return;
				self.$alert('获取转接列表失败，错误码(' + response + ')');
			})
		},

		// 转接
		transfer (obj) {
			var self = this;

			self.$store.commit('changeShowTransferList', false);

			if (self.transferType == 1) {
				var url = API_ROOT.url + '/SessionApi.transferSession';
			} else if (self.transferType == 2) {
				var url = API_ROOT.url + '/wwim/innerSessionTransfer';
			} else {
				var url = API_ROOT.url + '/wwim/transfer';
			}

			var data = {
				serviceType: self.currentShop.serviceType,
				sessionId: self.currentSessionId,
				toCustomerId: obj.id
			}

			self.$axios.post(url, data).then(result => {
				if (result.status) {
					self.$emit('closeSession', data.sessionId);
				} else {
					self.$alert('转接失败，失败原因：' + result.msg);
				}
			}, response => {
				self.$alert('转接失败，错误码(' + response + ')');
			})
		},

		// 智能检测输入的内容
		aiIntelligentDetection () {
			return
			var self = this,
				html = self.sendContent,
				conversationObj = self.conversationList.find(o => o.id == self.currentSessionId) || {},
				data = {
					shopId: self.currentShop.id,
					customerId: self.userInfo.id,
					clientName: conversationObj.clientNickName,
					customerName: conversationObj.customername,
					sessionId: self.currentSessionId,
					shopIds: []
				};

			if (self.inputCheckInterval) clearTimeout(self.inputCheckInterval);
			if (!self.sendContent.trim()) {
				self.detection = '';
				self.detectionClass = '';
				return;
			} else {
				self.detection = '检测中……';
				self.detectionClass = '';
			}

			self.inputCheckInterval = setTimeout(function() {
				data.input = TJ_IM.msgHtmlToTxt(self.sendContent, self.currentShop.serviceType);
				for (var i = 0; i < self.$store.state.shopList.length; i++) {
					var shopId = self.$store.state.shopList[i].id;
					data.shopIds.push(shopId);
				}

				data.shopIds = JSON.stringify(data.shopIds);
				data.time = +new Date();
				$.ajax({
					url: API_ROOT.detectionUrl + '/reminder/checkinput.do',
					data: data,
					type: 'get',
					contentType: "application/json;charset=UTF-8"
				}).done(function(result) {
					if (self.currentSessionId != data.sessionId || self.sendContent != html) return;

					try {
						result = JSON.parse(result);
					} catch(e){}

					if (typeof result == 'object' && result.status !== undefined) {
						if (!result.status) {
							self.detection = 'OK';
							self.detectionClass = 'ok';
						} else {
							var arr = JSON.parse(result.msg);
							self.detection = arr.length ? arr[0].msg : '?';
							self.detectionClass = 'warn';
						}
					} else {
						self.detection = '调用接口错误，错误原因：网络繁忙';
					}
				}).fail(function(e) {
					if (self.currentSessionId != data.sessionId || self.sendContent != html) return;
					self.detection = '调用接口错误，错误码：' + e.status;
				});
			}, 500);
		},

		// 保存未发送出去的信息
		saveUnSendContent (sessionId) {
			var self = this,
				key = 'UNSEND-' + sessionId,
				sendContent = self.$store.state.sendContent;

			if (!sessionId) return;

			sendContent ? sessionStorage.setItem(key, sendContent) : sessionStorage.removeItem(key);
			self.$store.commit('changeSendContent', '');
		},

		// 读取未发送出去的信息
		getUnSendContent (sessionId) {
			var self = this,
				key = 'UNSEND-' + sessionId;

			if (!sessionId || sessionStorage.getItem(key) === null) {
				self.$store.commit('changeSendContent', '');
			} else {
				self.$store.commit('changeSendContent', sessionStorage.getItem(key));
			}
		},

		// 在输入框中按下回车键
		enterMsg (e) {
			var self = this,
				$textarea = $('.ima_textarea');
				
			// 如果是选择快捷回复时点击的回车键也直接返回
			if (e.keyCode != 13 || self.$store.state.showAtList) return;

			e.preventDefault();
			e.returnValue = false;
			if (e.ctrlKey) {
				var sel = window.getSelection();
				if (sel.getRangeAt && sel.rangeCount) {
					var range = sel.getRangeAt(0);
					if (range.startOffset == document.getElementsByClassName('ima_textarea')[0].innerHTML.length) {
						var str = '<div><br></div>';
					} else {
						var str = '<br>';
					}
					TJ_IM.addStrToFocus(document.getElementsByClassName('ima_textarea')[0], str, function(text) {
						self.sendContent = text;
					});
				}
			} else {
				self.handleSendMessage(self.sendContent);
			}
		},

		// 发送图片
		sendImg(e) {
			var self = this,
				uploadUrl = API_ROOT.uploadUrl + '/raw/img/qiniuToken';

			if (!e.target.value) return;

			var file = e.target.files[0];
			var suffix = file.name.substring(file.name.lastIndexOf('.'));

			if (file.type.includes('video')) {
				self.sendMessage(file);
				$('.js-send-msg-pic input[type="file"]').val('');
			} else {
				TJ_IM.previewHandle(uploadUrl, e.target.files[0], function(html) {
					self.sendContent = html;
				});
			}
		},

		// 粘贴图片
		pasteUploadImg (e) {
			var self = this,
				uploadUrl = API_ROOT.uploadUrl + '/raw/img/qiniuToken';

			TJ_IM.pasteUploadImg(uploadUrl, e, function(html) {
				self.sendContent = html;
			});
		},

		// 微信、WEB、小程序消息需要一张一张的发图片，所以这里把消息进行了分割
		handleSendMessage (html, type) {
			var self = this;

			if (TJ_IM.isIMType(self.currentShop.serviceType)) {
				var $temp = $('<div>' + html + '</div>');
				$temp.find('img[data-type="uploading"]').each(function(){
					var html = '$%2a^gd*sa@#y%' + $(this).prop('outerHTML') + '$%2a^gd*sa@#y%';
					$(this).replaceWith(html);
				});
				var arr = $temp.html().split('$%2a^gd*sa@#y%');
				for (var i = 0; i < arr.length; i++) {
					if (arr[i]) self.sendMessage(arr[i], '', '', type);
				}
			} else {
				self.sendMessage(html, '', '', type);
			}
		},

		// 发送消息
		sendMessage (html, asideParam, callback, type) {
			var isVideo = (typeof html === 'object') && (html.type || '').includes('video');
			var self = this,
				shopId = self.currentShop.id,
				uploadUrl = API_ROOT.uploadUrl + '/raw/img/qiniuToken',
				msgContent = isVideo ? `<img data-type="video" style="background-color: #ccc" src="http://o8uhyuamh.bkt.clouddn.com/2024-09/IM-745ebb8e23d646d8967fe9767294eaef.png" />` : TJ_IM.htmlToMsgContent(html, self.currentShop.serviceType),
				conversationObj = self.conversationList.find(o => o.id == self.currentSessionId) || {},
				param = {
					sessionid: self.currentSessionId,
					receiver: conversationObj.clientid,
					sender: self.userInfo.user_account,
					msgContent: msgContent,
					msgFileUrl: null,
					msgtype: isVideo ? 3 : TJ_IM.htmlToMsgType(msgContent)
				}
			if (type == 'invite') {
				param.inviteType = true
			}
			var	temp = $.extend(param, asideParam || {}),
				formData = {
					serviceType: self.currentShop.serviceType,
					message: temp
				};

			if (!self.$store.state.userStatus) {
				self.$alert('您的当前咨询状态为离线，请在右上角切换对应的咨询为在线状态！');
				return;
			}
			if (!formData.message.msgContent) return;

			if (self.currentShop.id == -1) {
				// 离线消息主动发送消息
				var data = {
					serviceType: self.currentShop.serviceType,
					sessionId: self.currentSessionId,
					customerId: self.userInfo.id
				};
				self.$axios.post(API_ROOT.url + '/SessionApi.reopenSession', data).then(result => {
					if (result.status) {
						result.data.lastMsg = {msgContent: ''};
						result.data.customername = self.userInfo.real_name;
						TJ_DB.add(TJ_DB.C_Table, result.data, (dbres) => {
							if (dbres.error) {
								self.$message.error('10002: 本地数据库写入失败，请联系管理员')
							}
							self.$store.commit('changeAutoSelectedSession', true);
							self.$store.commit('changeCurrentShop', self.currentShop.selectObj);
							self.$store.commit('changeConversationType', conversationObj.uncloseable ? '2' : '');
							self.$store.commit('changeCurrentSessionId', result.data.id);
							bus.$emit('bus_updateConversationList', () => {
								self.handleSendMessage(html);
							})
						});
					} else {
						self.$alert('重开会话失败，失败原因：' + result.msg);
					}
				}, response => {
					self.$alert('重开会话失败，失败原因：网络繁忙');
				})
				return;
			} else if (conversationObj.closed) {
				// 已关闭的会话主动发送消息
				var data = {
					serviceType: self.currentShop.serviceType,
					sessionId: self.currentSessionId,
					customerId: self.userInfo.id
				};
				self.$axios.post(API_ROOT.url + '/SessionApi.reopenSession', data).then(result => {
					if (result.status) {
						result.data.lastMsg = {msgContent: ''};
						result.data.customername = self.userInfo.real_name;
						TJ_DB.add(TJ_DB.C_Table, result.data, (dbres) => {
							if (dbres.error) {
								self.$message.error('10003: 本地数据库写入失败，请联系管理员')
							}
							self.$store.commit('changeConversationType', conversationObj.uncloseable ? '2' : '');
							self.$store.commit('changeCurrentSessionId', result.data.id);
							bus.$emit('bus_updateConversationList', () => {
								self.handleSendMessage(html);
							})
						});
					} else {
						self.$alert('重开会话失败，失败原因：' + result.msg);
					}
				}, response => {
					self.$alert('重开会话失败，失败原因：网络繁忙');
				})
				return;
			}

			// 把发送出去的消息转换为存到本地的消息体格式
			var tempData = {
				isCustomer: 1,
				sendStatus: -1,
				senderNickName: conversationObj.customername,
				sessionid: self.currentSessionId,
				msgContent: formData.message.msgContent
			}
			if (type == 'invite') {
				tempData.inviteType = true
			}

			self.sendContent = '';
			TJ_DB.add(TJ_DB.M_Table, tempData, function (result) {
				if (result.error) {
					self.$message.error('10004: 本地数据库写入失败，请联系管理员')
				}
				sendMsgBefore(result.lastKey, tempData, type)
			});

			// 发送聊天消息前的页面渲染以及上传图片等操作
			function sendMsgBefore (lastKey, Data, type) {
				if (!conversationObj.data) conversationObj.data = [];
				var $msgObj = $('<div>' + formData.message.msgContent + '</div>'),
					msgIndex = conversationObj.data.length,
					msgKey = lastKey;

				conversationObj.data[msgIndex] = tempData;
				let tempArr = self.conversationList.map(o => o.id === conversationObj.id ? conversationObj : o)
				self.$store.commit('changeConversationList', tempArr);

				if ($msgObj.find('img[data-type="video"]').length) {
					$msgObj.find('img[data-type="video"]').each(function() {
						TJ_IM.uploadLocalImgFile(uploadUrl, html, function(src) {
							if (!src) {
								tempData.msgContent = `<img src="/static/image/load-fail.png" />`;
								self.$alert('上传视频失败');
							} else {
								tempData.msgContent = `<video src="${src}" style="max-width: 60%;" controls />`;
								if (!formData.message.msgFileUrl) formData.message.msgFileUrl = src;
							}
							formData.message.msgContent = tempData.msgContent;
							submitMsg(msgKey, msgIndex, type);
						})
					})
				} else if ($msgObj.find('img[data-type="uploading"]').length) {
					var uploadNum = 0,
						length = $msgObj.find('img[data-type="uploading"]').length;

					$msgObj.find('img[data-type="uploading"]').each(function() {
						var imgData = $(this).attr('src'),
							uploadSign = $(this).data('upload-sign'),
							file = TJ_IM.dataURLtoFile(imgData);

						if (file) {
							TJ_IM.uploadLocalImgFile(uploadUrl, file, function(src) {
								if (!src) {
									src = '/static/image/load-fail.png';
									self.$alert('上传图片失败');
								}
								file = null;
								uploadNum++;
								tempData.msgContent = TJ_IM.updateFormDataToUploadSuccess(uploadSign, src, tempData.msgContent);
								if (!formData.message.msgFileUrl) formData.message.msgFileUrl = src;
								if (uploadNum >= length) {
									formData.message.msgContent = tempData.msgContent;
									submitMsg(msgKey, msgIndex, type);
								}
							});
						} else {
							uploadNum++
							if (uploadNum >= length) {
								formData.message.msgContent = tempData.msgContent;
								submitMsg(msgKey, msgIndex, type);
							}
						}
					});
				} else {
					submitMsg(msgKey, msgIndex, type);
				}
			}

			// 提交发送请求
			function submitMsg (msgKey, msgIndex, type) {
				self.$axios.post(API_ROOT.url + '/MessageApi.sendMsg', formData).then(result => {
					if(type == 'invite') {
						self.$alert('已发送邀评信息~');
					}
					if (callback && typeof callback == 'function') callback(result);

					tempData.uuid = (result.status) ? result.data.uuid : 0;
					tempData.sendStatus = (result.status) ? 1 : 0;
					tempData.id = (result.status) ? result.data.msgId : 0;
					tempData.msgDateCreatedStr = (result.status) ? result.data.date : (new Date().format('yyyy-MM-dd hh:mm:ss'));
					updateMsgList(msgKey, msgIndex);

					var tempObj = {
						indexedDBCreateTime: +new Date(),
						indexedDBUpdateMsgTime: +new Date() + 30*24*60*60*1000,
						lastMsg: {
							sendStatus: tempData.sendStatus,
							msgContent: formData.message.msgContent
						},
						error: ''
					};
					if (result.status) {
						tempObj.aiReply = 0;
						tempObj.lastClientMsgTime = result.data.date;
						tempObj.unreply = false;
					}
					updateConversationList(tempObj);

					if (!result.status) {
						self.$alert('消息发送失败，失败原因：' + result.msg);
					}

				}, response => {
					tempData.uuid = 0;
					tempData.sendStatus = 0;
					tempData.msgDateCreatedStr = new Date().format('yyyy-MM-dd hh:mm:ss');
					updateMsgList(msgKey, msgIndex);

					var tempObj = {
						aiReply: 0,
						lastMsg: {
							sendStatus: 0,
							msgContent: formData.message.msgContent
						},
						error: ''
					};
					updateConversationList(tempObj);

					if (response) {
						self.$alert('消息发送失败，错误码：(' + response + ')');
					} else {
						self.$alert('消息发送失败。您的网络不稳定，请稍后再试！');
					}
				})
			}

			// 更新当前聊天信息
			function updateMsgList (msgKey, msgIndex) {
				TJ_DB.edit(TJ_DB.M_Table, msgKey, tempData, function() {
					let tempArr = self.conversationList.map(o => {
						if (o.id === formData.message.sessionid) {
							o.data[msgIndex] = tempData
						}
						return o
					})
					self.$store.commit('changeConversationList', tempArr);
				});
			}

			// 更新会话列表
			function updateConversationList (obj) {
				TJ_DB.edit(TJ_DB.C_Table, formData.message.sessionid, obj, function () {
					let tempArr = self.conversationList.map(o => {
						if (o.id === formData.message.sessionid) {
							Object.assign(o, obj)
						}
						return o
					})
					self.$store.commit('changeConversationList', tempArr);
				});
			}
		},

		// 消息记录
		getMsgLog () {
			var self = this,
				conversationObj = self.conversationList.find(o => o.id === self.currentSessionId) || {},
				data = {
					sessionId: self.currentSessionId,
					buyerNick: conversationObj.name
				};
			
			self.$store.commit('changeShowMsgLog', false);
			self.$axios.post(API_ROOT.baseUrl + '/api/wwim/queryHistoryChatRecord', data).then(result => {
				if (result.code == 200) {
					self.$store.commit('changeLoadMsgLog', false);
					self.$store.commit('changeMsgLog', self.$store.state.loading);
					self.$store.commit('changeShowMsgLog', true);
				} else {
					alert('获取消息记录失败，失败原因：' + result.msg);
				}
			}, response => {
				alert('获取消息记录失败，失败原因：网络繁忙');
			})
		},
		
		// 在输入框中使用快捷回复语
		bindQuickReply () {
			var self = this,
				$textarea = $('.ima_textarea');
			
			initAtwho('/');
			initAtwho('、');

			function initAtwho(at) {
				$textarea.atwho({
					at: at,
					limit: 200,
					displayTpl: "<li>${key}${replytext}</li>",//显示模板
					insertTpl: "${replytext}",//插入模板
					searchKey: "quicktext",
					callbacks: {
						filter:function(query){
							var arr = [],
								key = self.qRKey + $('.store .active').data('id'),
								json = sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key)) : '',
								sign = 0;

							if (query == '' || !json || !json.typeList) return arr;

							for (var i = 0; i < json.typeList.length; i++) {
								var typeObj = json.typeList[i];
								if (!typeObj.replyList) continue;

								for (var j = 0; j < typeObj.replyList.length; j++) {
									var dataObj = typeObj.replyList[j];
									if (dataObj.replytext.indexOf(query) > -1 || dataObj.quicktext.indexOf(query) > -1) {
										dataObj.key = (sign < 10) ? (sign + '、') : ' &nbsp;　 ';
										sign++;
										arr.push(dataObj);
									}
								};
							}
							return arr;
						}
					},
					selectAfterCallback: function () {
						var html = $textarea.html();
						console.log(html);
						self.$store.commit('changeSendContent', html);
					},
					showListCallback: function () {
						self.$store.commit('changeShowAtList', true);
					},
					hideListCallback: function () {
						self.$store.commit('changeShowAtList', false);
					}
				});
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/msgList/sendMsg.vue